import { render } from "./InputBoxAnnotation.vue?vue&type=template&id=6e67a88d&scoped=true"
import script from "./InputBoxAnnotation.vue?vue&type=script&lang=js"
export * from "./InputBoxAnnotation.vue?vue&type=script&lang=js"

import "./InputBoxAnnotation.vue?vue&type=style&index=0&id=6e67a88d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e67a88d"]])

export default __exports__